/**
 * oauth-grants-api.ts — the caller's connected OAuth (MCP connector) clients.
 *
 * GET    /oauth/grants             → 200 {"data": OAuthGrant[]}
 * DELETE /oauth/grants/{clientId}  → 204; 404 when the caller holds no live grant
 *
 * Session-only: API keys get 403. Revoking stops the client's next token
 * refresh; an access token it already holds keeps working until it expires
 * (at most 15 minutes), so the UI must not promise an instant disconnect.
 */
import { apiClient } from './index';

/** Mirrors oauth.Grant (backend/internal/oauth/repo.go). No token values. */
export interface OAuthGrant {
    client_id: string;
    client_name: string;
    /** RFC3339: when the client registered, just before first consent. */
    registered_at: string;
    /** RFC3339: newest refresh token; connectors rotate it while in use. */
    last_refreshed_at: string;
    scopes: string[];
}

export async function listOAuthGrants(): Promise<OAuthGrant[]> {
    const { data } = await apiClient.get<{ data: OAuthGrant[] }>('/oauth/grants');
    return data.data;
}

export async function revokeOAuthGrant(clientId: string): Promise<void> {
    await apiClient.delete(`/oauth/grants/${encodeURIComponent(clientId)}`);
}
